import React from 'react';
export var ReactReduxContext = /*#__PURE__*/React.createContext(null);

if ("production" !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

export default ReactReduxContext;